import EgIcon from "@/components/global/eg/eg_icon.vue";
import EgButton from "@/components/global/eg/buttons/eg_button.vue";
import EgModal from "@/components/global/eg/modals/eg_modal.vue";
import EgInput from "@/components/global/eg/eg_input.vue";
import EgRadioInput from "@/components/global/eg/eg_radio_input.vue";
import EgCheckboxInput from "@/components/global/eg/eg_checkbox_input.vue";
import EgToggle from "@/components/global/eg/eg_toggle.vue";
import EgDropdown from "@/components/global/eg_dropdown.vue";
import EgFormGroup from "@/components/global/eg_form_group.vue";
import EgCard from "@/components/global/eg_card.vue";
import EgTabs from "@/components/global/eg/eg_tabs.vue";
import EgPvTable from "@/components/global/eg/eg_pv_table/index.js";
import * as EgBootstrap from "@/components/global/eg/bootstrap";

const hyphenate = (str) => str.replace(/\B([A-Z])/g, "-$1").toLowerCase();

export default {
  install(Vue) {
    Object.keys(EgBootstrap).forEach((key) => {
      if (key.startsWith("EgB")) {
        const comp = EgBootstrap[key];
        Vue.component(key, comp);
        // Explicit kebab-case tags in templates: <eg-b-alert>, <eg-b-button>, …
        Vue.component(hyphenate(key), comp);
      }
    });

    Vue.component("EgIcon", EgIcon);
    Vue.component("EgButton", EgButton);
    Vue.component("EgModal", EgModal);
    Vue.component("EgInput", EgInput);
    Vue.component("EgRadioInput", EgRadioInput);
    Vue.component("EgCheckboxInput", EgCheckboxInput);
    Vue.component("EgToggle", EgToggle);
    Vue.component("EgDropdown", EgDropdown);
    Vue.component("EgFormGroup", EgFormGroup);
    Vue.component("EgCard", EgCard);
    Vue.component("EgTabs", EgTabs);
    Vue.component("EgPvTable", EgPvTable);
  },
};
